import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoText from '@/components/atoms/InfoText';

interface FeedbackOrderDetailsProps {
  orderId: string;
  logisticsCompanyName: string;
  date: string;
  time?: string;
  'data-testid'?: string;
}

export const FeedbackOrderDetails: React.FC<FeedbackOrderDetailsProps> = ({
  orderId,
  logisticsCompanyName,
  date,
  time,
  'data-testid': dataTestId = 'feedback-order-details-section',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="p-4 border rounded-xl bg-light-surface-primary dark:bg-dark-surface-primary border-light-input-border dark:border-dark-input-border space-y-4"
      data-testid={dataTestId}
    >
      <InfoText
        text={t('logisticsFeedback.detailsTitle')}
        className="!font-bold text-lg !text-light-primary dark:!text-dark-primary"
        data-testid={`${dataTestId}-title`}
      />

      <div className="space-y-4" data-testid={`${dataTestId}-list`}>
        <div
          className="flex items-center justify-between"
          data-testid={`${dataTestId}-order-id-row`}
        >
          <InfoText
            text={t('logisticsFeedback.orderId')}
            className="!text-base !font-normal !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-order-id-label`}
          />
          <InfoText
            text={orderId || '-'}
            className="!text-base !font-bold !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-order-id-value`}
          />
        </div>

        <hr className="border-light-input-border dark:border-dark-input-border" />

        <div
          className="flex items-center justify-between"
          data-testid={`${dataTestId}-company-row`}
        >
          <InfoText
            text={t('logisticsFeedback.logisticsCompanyName')}
            className="!text-base !font-normal !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-company-label`}
          />
          <InfoText
            text={logisticsCompanyName || '-'}
            className="!text-base !font-bold !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-company-value`}
          />
        </div>

        <hr className="border-light-input-border dark:border-dark-input-border" />

        <div
          className="flex items-center justify-between"
          data-testid={`${dataTestId}-date-row`}
        >
          <InfoText
            text={t('logisticsFeedback.date')}
            className="!text-base !font-normal !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-date-label`}
          />
          <InfoText
            text={date || '-'}
            className="!text-base !font-bold !leading-none !text-light-primary dark:!text-dark-primary"
            data-testid={`${dataTestId}-date-value`}
          />
        </div>

        {time && (
          <>
            <hr className="border-light-input-border dark:border-dark-input-border" />
            <div
              className="flex items-center justify-between"
              data-testid={`${dataTestId}-time-row`}
            >
              <InfoText
                text={t('logisticsFeedback.time')}
                className="!text-base !font-normal !leading-none !text-light-primary dark:!text-dark-primary"
                data-testid={`${dataTestId}-time-label`}
              />
              <InfoText
                text={time}
                className="!text-base !font-bold !leading-none !text-light-primary dark:!text-dark-primary"
                data-testid={`${dataTestId}-time-value`}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
